export enum SingleFilterOption {
  VEHICLE_ONLY = 'VEHICLE_ONLY',
  FAVOURITE_ONLY = 'FAVOURITE_ONLY',
  ALL_LABELS = 'ALL_LABELS',
  WITHOUT_SUBEQUIPMENTS = 'WITHOUT_SUBEQUIPMENTS',
  ONLY_LATEST_COMPLETED_FOR_RULE = 'ONLY_LATEST_COMPLETED_FOR_RULE',
  ONLY_DISPOSITION_GEOFENCES = 'ONLY_DISPOSITION_GEOFENCES'
}
